const initialState = {
  buyerPreferences: [],
  sellerPreferences: [],
  buyOther: false,
  sellOther: false,
  activityType: '',
  hasLoaded: false,
};

const preferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GetPreferences':
      return state;
    case 'InsertPreferences':
      return { ...action.payload };
    default:
      return state;
  }
};

export default preferencesReducer;
